import "./BtnTrocaImg.css"

function BtnTrocaImg(props) {
  return (
    <>
      <button className="btnTrocaImg" type="radio" style={{ backgroundColor: `${props.cor}` }}>{props.qtde}<br />{props.un}</button>
    </>
  )
}

export default BtnTrocaImg;